import { render, staticRenderFns } from "./ModalPreview.vue?vue&type=template&id=161a7f17"
import script from "./ModalPreview.vue?vue&type=script&lang=js"
export * from "./ModalPreview.vue?vue&type=script&lang=js"
import style0 from "./ModalPreview.vue?vue&type=style&index=0&id=161a7f17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports